import React from 'react';

const BorderBody = ({children, className}) => {
    return (
        <table className={["w-full border-collapse text-sm", className].join(" ")}>
            {children}
        </table>
    );
};

export default BorderBody;